import React from 'react';

import { useLocalization } from '../../providers/LocaleProvider';
import { BodyRegularBR1 } from '../Typography';

export interface ProductsShownInfoProps {
  count: number;
  totalCount: number;
  className?: string;
}

const ProductsShownInfo = ({ count, totalCount, className }: ProductsShownInfoProps) => {
  const { t } = useLocalization();

  return (
    <BodyRegularBR1 data-testid="products-shown-indicator" mb="sp_20" className={className}>
      {count} {t('h24_of')} {totalCount}
    </BodyRegularBR1>
  );
};

export default ProductsShownInfo;
